/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Directory_SearchInputs */

const en_features_directory_search = /** @type {(inputs: Features_Directory_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach nearby`)
};

const pl_features_directory_search = /** @type {(inputs: Features_Directory_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener w pobliżu`)
};

/**
* | output |
* | --- |
* | "Coach nearby" |
*
* @param {Features_Directory_SearchInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_directory_search = /** @type {((inputs?: Features_Directory_SearchInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Directory_SearchInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_directory_search(inputs)
	return en_features_directory_search(inputs)
});